// This is due to circular dependencies with supplements and orders. This isn't the final resting place for these constants, but it prevents the circular dependency for now.
export const SUPPLEMENTS_CONTAINER_ID = 10;
